module.exports = __webpack_public_path__ + "front/img/edm-banner-xianxia.6f6b4d4b.png";